import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {
  Account,
  Attachment,
} from '@nymos/accounts/core';


@Component({
  selector: 'nym-agent-business-info',
  templateUrl: './agent-business-info.component.html',
  styleUrls: ['./agent-business-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentBusinessInfoComponent implements OnInit {

  @HostBinding('class.nym-agent-business-info')
  protected get classes(): boolean { return true; }

  @Output()
  protected viewAttachments: EventEmitter<any> = new EventEmitter();

  @Input()
  public account: Account;

  protected get business(): any { return this.account && this.account.business; }

  protected get attachments(): Attachment[] {
    return this.account && this.account.business && this.account.business.attachments || [];
  }

  protected get urls(): string[] {
    return this.attachments.map((a) => a.url) || [];
  }

  constructor() { }

  public ngOnInit(): void { }

  protected viewAttachments$$(index: number): void {
    const attachments = this.attachments;
    this.viewAttachments.emit({ attachments, index });
  }
}
